export const tableStyles = {
	link: {
		color: '#007bff',
		textDecoration: 'none',
	},
	table: {
		borderCollapse: 'collapse' as const,
		width: '100%',
	},
	td: {
		border: '1px solid #ddd',
		padding: 4,
	},
	th: {
		backgroundColor: '#f5f5f5',
		border: '1px solid #ddd',
		padding: 4,
		textAlign: 'left' as const,
	},
};
